const OPTIONS = {
  8: "max-h-8",
  12: "max-h-12",
  16: "max-h-16",
  20: "max-h-20",
  24: "max-h-24",
  28: "max-h-28",
  32: "max-h-32",
  36: "max-h-36",
  40: "max-h-40",
  44: "max-h-44",
  48: "max-h-48",
  52: "max-h-52",
  56: "max-h-56",
  60: "max-h-60",
  64: "max-h-64",
  72: "max-h-72",
  80: "max-h-80",
  96: "max-h-96",
};

export default function getMaxHeight(height) {
  return OPTIONS[height];
}
